import queryString from "query-string";
import {setInternalToken} from "~/api/abortable-call";

export function grabInternalTokenFromQuery() {
    const internalToken = queryString.parse(window.location.search).tmb;
    if (internalToken) setInternalToken(internalToken);
}
